import { useState } from "react";
import useInfiniteScroll from "react-infinite-scroll-hook";
import SimpleSpinner from "../../../components/loader";
import EmptyState from "../../emptystate";
import { UnitVM } from "@propertelligent/client-api";
import { UnitService } from "@propertelligent/client-api";
import apiHelper from "../../../utils/apiHelper";
import UnitCardItem from "../../unit/UnitCardItem";
import { GetImages } from "../../../utils/GetImages";

interface DataHookState {
  rows: UnitVM[];
  loading: boolean;
  hasMore: boolean;
  fetchData: (page: number) => void;
  currentPage: number;
  onRefresh?: () => void;
}

interface UnitProps {
  Id?: any;
  className?: string;
  IsFooter?: boolean;
  hasAnyData?: boolean;
  setModalOpen?: (open: boolean) => void;
  dataHookState?: DataHookState;
  onEditUnit?: (unit: UnitVM) => void; // Add onEditUnit prop
  activeTab?: string; 
  isOccupied?: boolean;
}


const UnitCard: React.FC<UnitProps> = ({
  Id,
  className = "",
  IsFooter = true,
  hasAnyData = true,
  setModalOpen,
  dataHookState,
  onEditUnit, // Destructure onEditUnit
  activeTab = "all",
  isOccupied = false,
}) => {
  const { rows, loading, hasMore, fetchData, currentPage } = dataHookState!;
  const [showConfirmation, setShowConfirmation] = useState<string | null>(null);

  const loadMoreRecords = () => {
    if (!loading && hasMore) {
      fetchData(currentPage + 1);
    }
  };

  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage: hasMore,
    onLoadMore: loadMoreRecords,
    disabled: !hasMore,
    rootMargin: "0px 0px 100px 0px",
  });

const handleDeleteUnit = async (unitId: any) => {
  try {
    const res = await apiHelper(UnitService.deleteApiUnit, {
      successMessage: "Unit Deleted Successfully",
      showNotification: true,
    }, unitId);

    if (res?.data?.success) {
      if (dataHookState?.onRefresh) {
        dataHookState.onRefresh();
      } else {
        fetchData(1);
      }
      setShowConfirmation(null);
    }
  } catch (err) {
    console.error("Error deleting unit:", err);
    setShowConfirmation(null);
  }
};



  return (
    <div className="infinite-scroll-container">
      {rows.length === 0 && !loading ? (
        <EmptyState
          icon={GetImages.emptyStateUnit}
          heading={hasAnyData ? activeTab == "All"? "No Units Found" : `No ${activeTab} Units Found` : "Add Your First Unit"}
          isButton={hasAnyData ? false : true}
          isBorder={true}
          buttonLabel={hasAnyData ? "Add Unit" : "Add Unit"}
          onButtonClick={() => {
              setModalOpen(true);
            }}
        />
      ) : (
        <>
          {rows.map((listingData) => (
            <UnitCardItem
              className="no-side-margin"
              key={listingData.id}
              listingData={listingData}
              IsFooter={IsFooter}
              showConfirmation={showConfirmation}
              setShowConfirmation={setShowConfirmation}
              handleDeleteUnit={handleDeleteUnit}
              onEditUnit={onEditUnit} // Pass onEditUnit to UnitCardItem
              onPaymentAdded={() => fetchData(1)}
            />
          ))}
          {(loading || hasMore) && (
            <div ref={sentryRef} className="loading-trigger">
              {loading && (
                <SimpleSpinner
                  myClassName={rows.length === 0 ? "Icon50" : "Icon40"}
                />
              )}
            </div>
          )}
          
        </>
      )}
    </div>
  );
};

export default UnitCard;